import { useContext } from "react";
import { convertLineBreakToSpace } from "../utils/shared";
import { GlobalStateContext } from "../wrappers/GlobalContext";


function useSearch() {
    const { searchValues } = useContext(GlobalStateContext);


    const hasQuery = (currentSearchValues: SearchValue[]) => currentSearchValues.some(v => !!v.query);
    const hasMultipleBlocks = () => searchValues.length > 1;

    const buildQuery = () => {

        let query = "";
        let blockIndex = 0;
        for (const group of searchValues) {
            let i = 0;

            if (blockIndex > 0 && hasQuery(group.searchValues)) {
                query += ` ${group.operator.toUpperCase()} `;
            }

            if (hasQuery(group.searchValues) && hasMultipleBlocks()) query += "(";

            for (const item of group.searchValues) {
                if (item.query) {
                    const words = convertLineBreakToSpace(item.query).split(" ").filter(w => !!w);

                    if (i > 0) {
                        query += ` ${item.operator.toUpperCase()} `;
                    }

                    switch (item.mapping) {
                        case "all-words":
                            query += `(+${words.join(" +")})`;
                            break;
                        case "at-least-one":
                            query += `+(${words.join(" ")})`;
                            break;
                        case "not-contain":
                            query += `(-${words.join(" -")})`;
                            break;
                        case "exact":
                            query += `("${words.join(" ")}")`;
                            break;
                    }
                }
                i++;
            }

            if (hasQuery(group.searchValues) && hasMultipleBlocks()) query += ")";

            blockIndex++;
        }

        return query;
    }

    return {
        buildQuery
    }
}

export default useSearch
